import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { generatePdf } from './pdfGenerator';
import { getUserDetails } from './session-service';


export async function getRiskHazard(id?: string) {
    const response = await apiGet('core', `risk-hazard/${id}`);
    return response.content;
}


export async function addRiskHazard(newDetails: any) {
    const response = await apiPost('core', `risk-hazard`, newDetails);
    return response;
}

export async function updateRiskHazard(newDetails: any, id?: string) {
    if (!id) {
        id = getUserDetails().client_id;
    }
    const response = await apiPut('core', `risk-hazard/${id}`, newDetails);

    return response;
}

export async function removeRiskHazard(id: any) {
    return await apiDelete('core', `risk-hazard/${id}`);
}



export async function addRiskHazardChecklist(newDetails: any) {
    try {
        const response = await apiPost('core', `risk-hazard-checklist`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateRiskHazardChecklist(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `risk-hazard-checklist/${id}`, newDetails);

        return response;
    } catch (e) { }
}

export async function removeRiskHazardChecklist(id: any) {
    try {

        return await apiDelete('core', `risk-hazard-checklist/${id}`);
    } catch (e) { }
}